import StartIcon from "./icons/start";
import EndIcon from "./icons/end";
import StopIcon from "./icons/stop";
import PickupIcon from "./icons/pickup";
import PickupEndIcon from "./icons/pickup-end";
import DropoffIcon from "./icons/dropoff";
import DropoffEndIcon from "./icons/dropoff-end";
import DriverIcon from "./icons/driver";
import OrderIcon from "./icons/order";
import LiveDriverIcon from "./icons/live-driver";

import { OLD_COLORS, COLORS } from "../../constants";

const markerIcons = {
  start: {},
  end: {},
  stop: {},
  pickup: {},
  pickupEnd: {},
  delivery: {},
  deliveryEnd: {},
  driver: {},
  order: {},
  liveDriver: {},
};

const icons = {
  start: StartIcon,
  end: EndIcon,
  stop: StopIcon,
  pickup: PickupIcon,
  pickupEnd: PickupEndIcon,
  delivery: DropoffIcon,
  deliveryEnd: DropoffEndIcon,
  driver: DriverIcon,
  order: OrderIcon,
  liveDriver: LiveDriverIcon,
};

export const imageMaker = (color, type) => {
  return "data:image/svg+xml;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(icons[type](color))));
};

OLD_COLORS.forEach(color => {
  ["start", "end", "stop", "pickup", "delivery", "driver", "order", "pickupEnd", "deliveryEnd", "liveDriver"].forEach(
    type => {
      markerIcons[type][color] = imageMaker(`#${color}`, type);
    },
  );
});

COLORS.forEach(color => {
  ["start", "end", "stop", "pickup", "delivery", "driver", "order", "pickupEnd", "deliveryEnd", "liveDriver"].forEach(
    type => {
      markerIcons[type][color] = imageMaker(`#${color}`, type);
    },
  );
});

export default markerIcons;
